module.exports = __webpack_public_path__ + "media/images/home-8693fb5b52547fa22383304ec3c71487.svg";